export function getRegisterURLC2B(lang){
    const laravel=`
    $url = 'https://sandbox.sasapay.app/api/v1/payments/request-payment/';
    $data = [
      'MerchantCode' => '{{REPLACE_HERE}}',
      'NetworkCode' => '{{REPLACE_YOUR_NETWORK_CODE_HERE}}',
      'PhoneNumber' => '{{REPLACE_PHONE_NUMBER_HERE}}',
      'TransactionDesc' => '{{REPLACE_YOUR_TRANSACTION_REFERENCE_HERE}}',
      'AccountReference' => '{{REPLACE_YOUR_ACCOUNT_REFERENCE_HERE}}',
      'TransactionDesc' => '{{REPLACE_YOUR_DESCRIPTION_HERE}}',
      'Currency' => '{{REPLACE_YOUR_CURRENCY_HERE}}',
      'Amount' => '{{REPLACE_AMOUNT_HERE}}',
      'CallBackURL' => '{{REPLACE_YOUR_CALLBACK_URL_HERE}}',
    ];
    
    $ch = curl_init($url);
    curl_setopt($ch, CURLOPT_POST, 1);
    curl_setopt($ch, CURLOPT_HTTPHEADER, ['Authorization':"Bearer TOKEN"]);
    curl_setopt($ch, CURLOPT_POSTFIELDS, http_build_query($data));
    curl_setopt($ch, CURLOPT_RETURNTRANSFER, true);
    
    $response = curl_exec($ch);
    curl_close($ch);
    
    echo $response;
    `;
    const python=`
        import requests
        import json
        
        url = "https://sandbox.sasapay.app/api/v1/payments/request-payment/"
        
        payload = json.dumps({
          "MerchantCode": "600980",
          "NetworkCode": "63902",
          "PhoneNumber": "***************",
          "TransactionDesc": "Pay for groceries",
          "AccountReference": "**************",
          "Currency": "KES",
          "Amount": 2,
          "TransactionFee": 0,
          "CallBackURL": "https://posthere.io/4bdd-47d5-a54d/callback/"
        })
        headers = {
          'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0b2tlbl90eXBlIjoiYWNjZXNzIiwiZXhwIjoxNjc1ODUzNzEwLCJpYXQiOjE2NzU4NTAxMTAsImp0aSI6ImY0ZjYwMjY2MjVkNjQ2ZDBiYWM0MjQzMmVhNDU4NWQyIiwidXNlcl9pZCI6Mn0.lz31rlb8odNWMX-T88wvNx4k901JgJiciazQPVb4S-k',
          'Content-Type': 'application/json'
        }
        
        response = requests.request("POST", url, headers=headers, data=payload)
        
        print(response.text)

    `
    const javascript=`
        const unirest = require('unirest');
        const req = unirest('POST', 'https://sandbox.sasapay.app/api/v1/payments/request-payment/')
          .headers({
            'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0b2tlbl90eXBlIjoiYWNjZXNzIiwiZXhwIjoxNjc1ODUzNzEwLCJpYXQiOjE2NzU4NTAxMTAsImp0aSI6ImY0ZjYwMjY2MjVkNjQ2ZDBiYWM0MjQzMmVhNDU4NWQyIiwidXNlcl9pZCI6Mn0.lz31rlb8odNWMX-T88wvNx4k901JgJiciazQPVb4S-k',
            'Content-Type': 'application/json'
          })
          .send(JSON.stringify({
            "MerchantCode": "600980",
            "NetworkCode": "63902",
            "PhoneNumber": "**********",
            "TransactionDesc": "Pay for groceries",
            "AccountReference": "****************",
            "Currency": "KES",
            "Amount": 2,
            "TransactionFee": 0,
            "CallBackURL": "https://posthere.io/4bdd-47d5-a54d/callback/"
          }))
          .end(function (res) { 
            if (res.error) throw new Error(res.error); 
            console.log(res.raw_body);
          });

    `
    const java=`
        public static JSONObject customerToBusiness(String bearerToken) throws Exception {

    // NetworkCodes   SasaPay(0) 63902(MPesa) 63903(AirtelMoney) 63907(T-Kash)

    Random rand = new Random();
    int number = rand.nextInt(100);

    String url = "Endpoint";

    Map<String, Object> body = Map.of(
            "MerchantCode", "merchant_code",
            "NetworkCode", "network_code",
            "PhoneNumber", "2547******39",
            "TransactionDesc", "description",
            "AccountReference", number,
            "Currency", "KES",
            "Amount", 5,
            "TransactionFee", 0,
            "CallBackURL", "https://posthere.io/37c6-44a6-a2f4");


    URL obj = new URL(url);
    HttpURLConnection con = (HttpURLConnection) obj.openConnection();

    // Set request method
    con.setRequestMethod("POST");

    // Add bearer token to authorization header
    con.setRequestProperty("Authorization", "Bearer " + bearerToken);

    // Set request content type
    con.setRequestProperty("Content-Type", "application/json");

    // Set request body
    JSONObject jsonObject = new JSONObject(body);
    String requestBody = jsonObject.toString();

    // Send post request
    con.setDoOutput(true);
    DataOutputStream out = new DataOutputStream(con.getOutputStream());
    out.writeBytes(requestBody);
    out.flush();
    out.close();

    int responseCode = con.getResponseCode();
    if (responseCode != 200) {
        throw new Exception("Response code: " + responseCode);
    }

    // Get response
    BufferedReader in = new BufferedReader(new InputStreamReader(con.getInputStream()));
    String inputLine;
    StringBuilder response = new StringBuilder();
    while ((inputLine = in.readLine()) != null) {
        response.append(inputLine);
    }
    in.close();

    // Return response as JSONObject
    return new JSONObject(response.toString());
}
    `


    if (lang==='java') {
        return java;
    } else if (lang==='python') {
        return python
    }
    else if (lang==='javascript') {
        return javascript
    } else {
        return laravel
    }
}
export function getC2BMakeRequestResponse(){
    return `
    {
      "status": true,
      "detail": "OTP sent. Share the code to complete transaction",
      "PaymentGateway": "SasaPay",
      "MerchantRequestID": "07102440280",
      "CheckoutRequestID": "b6cb451a-ef9f-443d-8e64-045c210131df",
      "ResponseCode": "0",
      "ResponseDescription": "Success. Request accepted for processing",
      "CustomerMessage": "For manual payment Go to SasaPay App/USSD \\n Select Paybill \\nEnter Business number 94000\\n Enter account Number 07102440280\\nEnter Amount 1Enter M-pesa pin"
    }
    `
}